import { fetch } from '@atlassian/eoc-fetch';

import {
	type AISuggestions,
	type Group,
	type GroupActionResponse,
	type GroupActionType,
} from '../../common/types';
import { withAIOpsPrefix } from '../../common/utils';

export const getHeaderDetails = (groupId: string) =>
	fetch<Group>(withAIOpsPrefix(`/v1/group-insights/${groupId}`), {
		exactUrl: true,
	});

export const getAISuggestions = (groupId: string) =>
	fetch<AISuggestions>(withAIOpsPrefix(`/v1/group-insights/getSimilar/${groupId}`), {
		exactUrl: true,
	});

export const addGroupAssignee = (groupId: string, assigneeId: string) =>
	fetch<Group>(withAIOpsPrefix(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
		method: 'PUT',
		exactUrl: true,
	});

export const actionOnGroup = (
	groupId: string,
	action: GroupActionType,
	payload: Record<string, unknown> = {},
) => {
	return fetch<GroupActionResponse>(withAIOpsPrefix(`/v1/alert-insights/bulk-action`), {
		method: 'PUT',
		exactUrl: true,
		body: {
			groupId: groupId,
			actionType: action,
			...payload,
		},
	});
};

export const getAlertCountForGroupAction = (groupId: string, action: GroupActionType) => {
	const urlSearchParams = new URLSearchParams();
	urlSearchParams.set('actionType', action);
	urlSearchParams.set('groupId', groupId);
	return fetch<GroupActionResponse>(
		withAIOpsPrefix(`/v1/alert-insights/check-all-action?${urlSearchParams}`),
		{
			exactUrl: true,
		},
	);
};
